import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { map } from "lodash";
import { Rotas } from "./components/app/home/menuRotas";
import PrivateRoleRoute from "./components/util/routes/privateRoleRoute";
import PublicRoute from "./components/util/routes/publicRoute";
import RootRedirectRoute from "./components/util/routes/rootRedirectRoute";
import Login from "./components/app/login";
import Registro from "./components/app/registro";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Rota raiz que redireciona com base na autenticação */}
        <Route path="/" element={<RootRedirectRoute />} />

        {/* Rotas públicas */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/registrar"
          element={
            <PublicRoute>
              <Registro />
            </PublicRoute>
          }
        />

        {/* Rotas privadas com controle de permissões */}
        {map(Rotas, (rota) => (
          <Route
            key={rota.titulo}
            path={rota.pathname}
            element={
              <PrivateRoleRoute match={rota.permissao}>
                <rota.componente />
              </PrivateRoleRoute>
            }
          />
        ))}
      </Routes>
    </Router>
  );
}
